import { render, staticRenderFns } from "./DiscountedGoodsCard.vue?vue&type=template&id=da09922a&"
import script from "./DiscountedGoodsCard.vue?vue&type=script&lang=js&"
export * from "./DiscountedGoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscountedGoodsCard.vue?vue&type=style&index=0&id=da09922a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports